export default function (props: any) {
    return (
        <svg
            width="16px"
            height="11px"
            viewBox="0 0 16 11"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Offcial-Online-Stroes备份" transform="translate(-254.000000, -585.000000)" fill="#D8D8D8">
                    <g id="编组-2" transform="translate(173.000000, 345.000000)">
                        <g id="编组-5" transform="translate(81.000000, 240.500000)">
                            <polygon
                                id="三角形"
                                transform="translate(12.500000, 5.000000) rotate(-270.000000) translate(-12.500000, -5.000000) "
                                points="12.5 2 17.5 8 7.5 8"
                            ></polygon>
                            <rect id="矩形" x="0" y="3.5" width="10" height="3"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
